export default __webpack_public_path__ + "static/media/author.54278bdb.jpeg";